export const endpoints = {
  query: '/contact',
  create: '/contact',
  get: '/contact/:contactId',
  edit: '/contact/:contactId',
  remove: '/contact/:contactId/removeAccount',
}
